import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { useIdentityContext } from '@99designs/design-services-common';
import { FullPageSpinner } from '@99designs/design-services-layouts';
import { NotFoundErrorPage } from '../lib';
import Index from './routes';
import { Applicants } from './routes/applicants';
import { Matching } from './routes/matching';
import { Overview } from './routes/overview';

export function SignOut() {
    const identity = useIdentityContext();
    const navigate = useNavigate();

    useEffect(() => {
        identity.SignOut();
        navigate('/');
    });

    return <FullPageSpinner />;
}

export function AppRoutes() {
    return (
        <Routes>
            <Route index element={<Index />} />
            <Route path=":jobId" element={<Matching />}>
                <Route path="overview" element={<Overview />}></Route>
                <Route path="applicants" element={<Applicants />}></Route>
            </Route>

            {/* This route is only available in development to aid in account switching. */}
            {process.env.NODE_ENV === 'development' && (
                <Route path="sign-out" element={<SignOut />}></Route>
            )}

            <Route path="*" element={<NotFoundErrorPage />} />
        </Routes>
    );
}
